'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { type ReactNode, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { CruzIcon } from '@/components';
type Props = {
  imgUrl?: string;
  title: string;
  content: string | ReactNode;
};
export function PageDescription(t0) {
  const $ = _c(28);
  const {
    imgUrl,
    title,
    content
  } = t0;
  const sectionRef = useRef(null);
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleClick() {
      setOpen(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClick = t1;
  const t2 = open && "rounded-b-none";
  let t3;
  if ($[1] !== t2) {
    t3 = twMerge("flex w-full items-center rounded border gap-x-3 px-4 py-3", "hover:bg-zinc-200/70 dark:hover:bg-zinc-700", t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== open) {
    t4 = open ? <CruzIcon.Minus aria-hidden="true" /> : <CruzIcon.Plus aria-hidden="true" />;
    $[3] = open;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== title) {
    t5 = <span className="flex items-center gap-x-3"><span className="block text-base font-semibold dark:font-normal">{title}</span></span>;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== open || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <h2 className="my-0! py-0!" id="page-description-heading"><button type="button" className={t3} onClick={handleClick} aria-expanded={open} aria-controls="page-description-content">{t4}{t5}</button></h2>;
    $[7] = open;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = open ? "opacity-100" : "hidden opacity-0";
  let t8;
  if ($[12] !== t7) {
    t8 = twMerge("rounded-b-sm border-r border-b border-l px-4 font-light sm:px-6", t7);
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== imgUrl || $[15] !== title) {
    t9 = imgUrl && <div className="hidden sm:block md:min-w-[161px]"><Image width={610} height={713} src={imgUrl} alt={title} priority={true} className="m-auto w-full rounded-md object-cover shadow-lg" /></div>;
    $[14] = imgUrl;
    $[15] = title;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== content) {
    t10 = <div className="grow">{content}</div>;
    $[17] = content;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="flex max-w-7xl gap-x-8 py-6">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t8) {
    t12 = <div id="page-description-content" className={t8}>{t11}</div>;
    $[22] = t11;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t6) {
    t13 = <section className="mt-3 mb-6" ref={sectionRef} aria-labelledby="page-description-heading">{t6}{t12}</section>;
    $[25] = t12;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
function _temp(prev) {
  return !prev;
}